import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const PostLoginNotificationsQuery = gql`
  query PostLoginNotifications {
    getUnreadNotifications {
      id
    }
  }
`;

const usePostLoginNotifications = () => {
  const { idpToken } = useSelector(select.session.get);

  const { data } = Apollo.useQuery(PostLoginNotificationsQuery, {
    fetchPolicy: 'no-cache',
    skip: !idpToken
  });

  return !!data?.getUnreadNotifications.length;
};

export default usePostLoginNotifications;
